import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./E4ControlActivities.scss"

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, cSectionFormFields } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const E4ControlActivities = forwardRef(({ e4ControlActivities,vesselMstId, refetchMonitoringData }, ref) => {

    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (e4ControlActivities) {
            reset(prev => ({ ...prev, e4: e4ControlActivities }));
        }
    }, [e4ControlActivities, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("e4");
        const payload = {
            ...filteredAndRemappedFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const e4ControlActivities = await callApi({
                method: "POST",
                url: API_ROUTES.E4(vesselMstId),
                data: payload,
            });
            if (e4ControlActivities?.isSuccess) {
                emitToasterMsg("success", "Table E.4", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, e4: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table E.4", e4ControlActivities?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table E.4", error?.errorMessage);
        }
    };

    const filteredAndRemappedFields = cSectionFormFields
        .filter(field => field.name !== "versionOfProcedure" && field.name !== "formulaeAndDataSources")
        .map(field => {
            if (field.name === "itSystemName") {
                return { ...field, name: "systemName" };
            }
            if (field.name === "referenceToProcedure") {
                return {
                    ...field,
                    label: "Reference for procedure",
                };
            }
            return field;
        });

    // Add extra field if needed
    filteredAndRemappedFields.push({
        label: "List of relevant existing management systems",
        name: "managementSystemsList",
        maxLength: 1000,
    });

    return (
        <div className="e4-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="6">
                    <h6 className="titles-font">Information Technology Management (e.g. access controls, back up, recovery and security)</h6>
                </MDBCol>
            </MDBRow>

            {filteredAndRemappedFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`e4.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`e4_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="e4_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                    disabled={!isDirty}
                >Save</Button>
            </div>
        </div>
    );
});

export default E4ControlActivities;